import styles from '../../Navigation/Unauthorized/AccountDropdown.module.css';
import cls from 'clsx';
import SelectIcon from '../../../public/images/icons/select.svg';
import { Spinner } from '../../Spinner/Spinner';

export const SelectDropdown = (props: any) => {
    return (
        <div  className={cls('dropdown dropdown-bottom h-[54px]', styles.account_dropdown, props.className)}>
        <label style={{
            borderRadius: '16px',
            border: '3px solid #373a41'
        }} tabIndex={0} className="btn font-bold bg-base-300 m-1 hover:bg-outline normal-case flex flex-row gap-x-4">
            {props.isLoading ? <Spinner /> :  props.value}
        <SelectIcon className="w-6 h-8 text-white -mr-[14px]" />
        </label>
        <ul tabIndex={0} className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52"
        >
            {!props.isLoading && props.children.map((c: any, idx: any) => {
                const isSelected = props.value === props.entries[idx];

                return (
                    <li className={cls({
                        ['bg-outline rounded-lg']: isSelected
                    })} onClick={() => (document.activeElement as any).blur()} key={idx}>{c}</li>
                )
            })}
        </ul>
    </div>
    )
}